'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagCxAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "#0637C5" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.33335 17.3334L4.39054 17.6095L4.66669 16.6667L4.39054 15.7239L5.33335 16L6.27616 15.7239L6.00002 16.6667L6.27616 17.6095L5.33335 17.3334Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.33335 7.33335L4.39054 7.60949L4.66669 6.66669L4.39054 5.72388L5.33335 6.00002L6.27616 5.72388L6.00002 6.66669L6.27616 7.60949L5.33335 7.33335Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.00002 11.3334L7.05721 11.6095L7.33335 10.6667L7.05721 9.72388L8.00002 10L8.94283 9.72388L8.66669 10.6667L8.94283 11.6095L8.00002 11.3334Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.66669 12.6667L1.72388 12.9428L2.00002 12L1.72388 11.0572L2.66669 11.3334L3.6095 11.0572L3.33335 12L3.6095 12.9428L2.66669 12.6667Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.33347 14.3333L6.86206 14.4714L7.00013 14L6.86206 13.5286L7.33347 13.6666L7.80487 13.5286L7.6668 14L7.80487 14.4714L7.33347 14.3333Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M28 20L16.1056 11.5039C16.1056 11.5039 13.4624 12.8712 12.4522 12.1497C11.4421 11.4281 11.99 8.56421 11.99 8.56421L0 0H28V20Z",
          fill: "#3BA758"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.2812 10C19.2812 10 22.5004 9.46761 22.8844 7.96452C23.2684 6.46143 19.8205 5.38549 19.684 4.84505C19.5475 4.30461 20.9512 4.68806 21.5714 4.84505C22.1725 4.99725 23.3479 5.77262 23.3479 5.77262C23.3479 5.77262 23.3337 4.70528 23.1734 4.2124C22.9041 3.38415 22.0592 1.80924 22.0592 1.80924C22.0592 1.80924 23.4924 2.72848 24.1073 3.46224C24.4597 3.88268 24.5915 5.77994 25.0271 6.43018C25.8061 7.59302 27.6237 6.29482 26.8515 7.52751C26.0793 8.7602 24.3041 8.92773 22.8844 9.46761C21.597 9.95719 18.7302 10.6159 18.7302 10.6159L19.2812 10Z",
          fill: "#FFCC5D"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.0001 13.3333C12.1591 13.3333 10.6667 11.8409 10.6667 10C10.6667 8.15905 12.1591 6.66667 14.0001 6.66667C15.841 6.66667 17.3334 8.15905 17.3334 10C17.3334 11.8409 15.841 13.3333 14.0001 13.3333ZM12.3444 10L12.0001 10.6667C12.0001 10.6667 13.119 10.4144 13.4973 10.6667C14.0097 11.0082 14.0001 12 14.0001 12H14.6667C14.6667 12 14.4487 11.0272 14.791 10.3426C15.1333 9.65801 16.0001 9.33333 16.0001 9.33333V8C16.0001 8 15.0918 8.96944 14.0001 9.33333C12.9084 9.69722 12.0001 9.33333 12.0001 9.33333L12.3444 10Z",
          fill: "#FFCC5D"
        }
      )
    ]
  }
);
const VpFlagCxAsset = forwardRef(FlagCxAsset);

export { VpFlagCxAsset as default };
